import {defineStore} from 'pinia'

export const useBaseStore = defineStore('baseStore', {
  state: () => (
    { 
      selectedFlow: []
    })
})

